import * as React from 'react';
import { connect } from 'react-redux';
import WorkOrderTableRowBuyer from '../WorkOrderTable/WorkOrderTableRow/buyer';
import WorkOrderTableRowSupplier from '../WorkOrderTable/WorkOrderTableRow/supplier';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { DELIVERABLES_GRAPH_TC } from '../../utils/DeliverableUtils';

// The standard work order row plus the deliverable pill. A work order doc doesn't say
// which deliverable it belongs to — the deliverable holds workOrderIds — so the name
// is looked up from the project's full deliverable list (fetched by
// ProjectsWorkOrdersPage). Reading it from Redux here rather than through
// CustomWorkOrderRowDisplayProps keeps the pill current: WOTable memoises its columns
// without those props, so a list that lands after the rows would never reach them.
const ProjectWorkOrderRow = ({ userType, deliverableName, dispatch, ...rowProps }: any) => {
	const Row = userType === ROLE_TYPES.SUPPLIER ? WorkOrderTableRowSupplier : WorkOrderTableRowBuyer;
	return <Row {...rowProps} deliverableName={deliverableName} />;
};

const mapStateToProps = (state, ownProps) => {
	const workOrderId = nullSafeGet('record.id', ownProps);
	// The graph collection holds whichever project was fetched last, so match the
	// project too — a stale list from another project must not label this one's rows.
	const deliverable = getRecordsForTargetCollection(state.deliverables, DELIVERABLES_GRAPH_TC).find(
		(entry) =>
			`${nullSafeGet('projectId', entry)}` === `${ownProps.projectId}` &&
			nullSafeGetOrElse('workOrderIds', entry, []).some((id) => `${id}` === `${workOrderId}`)
	);
	return { deliverableName: deliverable ? nullSafeGet('name', deliverable) : null };
};

export default connect(mapStateToProps)(ProjectWorkOrderRow);
